(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('MembershipFeeSearch', MembershipFeeSearch);

    MembershipFeeSearch.$inject = ['$resource'];

    function MembershipFeeSearch($resource) {
        var resourceUrl =  'api/_search/membership-fees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
